module.exports = __webpack_public_path__ + "img/bg_l1.4408f519.jpg";